import moment from 'moment'
// eslint-disable-next-line no-warning-comments
// TODO: Look into changing type further down (i.e. MapVisualizer)
export const getMapErrors = (state: RootState) => state.api && state.api.errors ? state.api.errors : 0
export const getMapInstanceSettings = (state: RootState) => state.mapVisualizer ? state.mapVisualizer.instanceSettings : undefined
export const getLeaderboardErrors = (state: RootState) => state.leaderboard && state.leaderboard.api ? state.leaderboard.api.errors : 0
export const getLeaderboardInstanceSettings = (state: RootState) => state.leaderboard ? state.leaderboard.instanceSettings : undefined
export const getDonorRollErrors = (state: RootState) => state.donorRoll && state.donorRoll.api ? state.donorRoll.api.errors : 0
export const getDonorRollInstanceSettings = (state: RootState) => state.donorRoll ? state.donorRoll.instanceSettings : undefined
export const getAffiliationErrors = (state: RootState) => state.affiliation && state.affiliation.api ? state.affiliation.api.errors : 0
export const getAffiliationInstanceSettings = (state: RootState) => state.affiliation ? state.affiliation.instanceSettings : undefined
export const getAmbassadorErrors = (state: RootState) => state.ambassador && state.ambassador.api ? state.ambassador.api.errors : 0
export const getAmbassadorInstanceSettings = (state: RootState) => state.ambassador ? state.ambassador.instanceSettings : undefined
export const getCampaignDashboardInstanceSettings = (state: RootState) => state.dashboard ? state.dashboard.instanceSettings : undefined
export const getViewChallengeInstanceSettings = (state: RootState) => state.viewchallenge ? state.viewchallenge.instanceSettings : undefined
export const getViewChallengeErrors = (state: RootState) => state.viewchallenge && state.viewchallenge.api ? state.viewchallenge.api.errors : 0
export const getCampaignDashboardErrors = (state: RootState) => state.dashboard && state.dashboard.api ? state.dashboard.api.errors : 0
export const getControlId = (state: RootState) => state.config.controlId
export const getApiPollingTimeInterval = (state: RootState) => {
    return state.apiPolling && state.apiPolling.timeInterval
}
export const getData = (state: RootState) => state.mapVisualizer && state.mapVisualizer.data
export const getGradientMapLookup = (state: RootState) =>
    state.mapVisualizer && state.mapVisualizer.gradientMapBoundaryLookup

export const getGradientMapSourceType = (state: RootState) => {
    const settings = getMapInstanceSettings(state)
    return settings ? settings.layoutSettings.gradientMapSourceType : 'Dollars'
}

export const buildMapObject = (result: MapSettingsDto): DataApiSettings => ({
    transactionStartDateTime: moment(result.transactionStartDateTime).format(),
    transactionEndDateTime: moment(result.transactionEndDateTime).format(),
    displayStartDateTime: moment(result.displayStartDateTime).format(),
    displayEndDateTime: moment(result.displayEndDateTime).format(),
    formIds: result.selectedControlIds,
    scoreboardTypeId: result.scoreboardTypeId,
})

export const getChallengeRequestPayload = (state: RootState): ChallengeRequestPayload => {
    const currentIndex = state.ambassador && state.ambassador.currentIndex ? state.ambassador.currentIndex : 0
    const challengeCurrentIndex = state.ambassador && state.ambassador.challengeCurrentIndex ? state.ambassador.challengeCurrentIndex : 0
    const selectedInitiative = state.ambassador && state.ambassador.data && state.ambassador.data[currentIndex] ? state.ambassador.data[currentIndex] : { FundraisingInitiativeId: 0, ParentFormId: 0 }
    const controllid = state.config.controlId
    return {
        initiativeId: selectedInitiative.FundraisingInitiativeId,
        parentFormId: selectedInitiative.ParentFormId,
        pageIndex: challengeCurrentIndex,
        controllid: controllid
    }
}

export const getViewChallengeRequestPayload = (state: RootState): ViewChallengeRequestPayload => {
    const challengeId = (state.viewchallenge && state.viewchallenge.instanceSettings && state.viewchallenge.instanceSettings.layoutSettings.challengeId) ? state.viewchallenge.instanceSettings.layoutSettings.challengeId : 0;
    const parentFormId = (state.viewchallenge && state.viewchallenge.instanceSettings && state.viewchallenge.instanceSettings.layoutSettings.parentFormId) ? state.viewchallenge.instanceSettings.layoutSettings.parentFormId : 0;
    const initiativeId = (state.viewchallenge && state.viewchallenge.instanceSettings && state.viewchallenge.instanceSettings.layoutSettings.initiativeId) ? state.viewchallenge.instanceSettings.layoutSettings.initiativeId : 0;
    return {
        challengeId,
        initiativeId,
        parentFormId
    }
}

export const getAmbasssadorProfileRequestPayload = (state: RootState): AmbassadorProfileRequestPayload => {
    const currentIndex = state.ambassador && state.ambassador.selectedChallengeIndex ? state.ambassador.selectedChallengeIndex - 1 : 0
    const ambassadorDetails = state.ambassador && state.ambassador.challengeData ? state.ambassador.challengeData[currentIndex] : { CreatedBy: { AmbassadorId: 0, AmbassadorName: '' } }
    return {
        CreatedBy: {
            AmbssadorId: ambassadorDetails.CreatedBy ? ambassadorDetails.CreatedBy.AmbassadorId : 0,
            AmbassdorName: ambassadorDetails.CreatedBy ? ambassadorDetails.CreatedBy.AmbassadorName : '',
        }
    }
}

export const getViewAmbasssadorProfileRequestPayload = (state: RootState): ViewAmbassadorProfileRequestPayload => {
    const ambassadorDetails = state.viewchallenge?.challengeData?.CreatedBy?.AmbassadorId ?? 0;
    return {
        AmbssadorId: ambassadorDetails,
    }
}
export const getAfterSocialShareUrl = (state: RootState): string => state.ambassador && state.ambassador.afterSocialShareUrl ? state.ambassador.afterSocialShareUrl : ''
